<div nz-row [nzGutter]="16">
    
    <div nz-col [nzSpan]="16">
        <nz-card nzTitle="Drive Explorer" class="shadow-sm">
            
            <nz-breadcrumb style="margin-bottom: 16px;">
                @for (crumb of breadcrumbs; track crumb.name; let i = $index) {
                    <nz-breadcrumb-item>
                        <a (click)="navigateToBreadcrumb(i, crumb)">{{ crumb.name }}</a>
                    </nz-breadcrumb-item>
                }
            </nz-breadcrumb>

            <nz-table #basicTable [nzData]="files" [nzLoading]="loading" [nzPageSize]="10" nzSize="middle">
                <thead>
                    <tr>
                        <th nzWidth="50px"></th> <th>Name</th>
                        <th nzAlign="center">Action</th>
                    </tr>
                </thead>
                <tbody>
                    @for (item of basicTable.data; track item.id) {
                        <tr>                        
                            <td nzAlign="center">
                                <span nz-icon [nzType]="isFolder(item.mimeType) ? 'folder' : 'file'" 
                                    [nzTheme]="isFolder(item.mimeType) ? 'twotone' : 'outline'" 
                                    nzTwotoneColor="#1890ff"></span>
                            </td>
                            
                            <td>
                                @if (isFolder(item.mimeType)) {
                                    <a (click)="openFolder(item)" style="cursor: pointer; font-weight: 500;">
                                        {{ item.name }}
                                    </a>
                                }
                                @if (!isFolder(item.mimeType)) {
                                    <span>{{ item.name }}</span>
                                }
                            </td>

                            <td nzAlign="center">
                                @if (isFolder(item.mimeType)) {
                                    <button nz-button nzType="default" nzSize="small" (click)="openFolder(item)">
                                        Open
                                    </button>
                                }
                                
                                @if (canPackage && !isFolder(item.mimeType)) {
                                    <button nz-button 
                                            [nzType]="isFileSelected(item.id) ? 'primary' : 'default'" 
                                            nzSize="small" 
                                            (click)="toggleSelection(item)">
                                        {{ isFileSelected(item.id) ? 'Selected' : 'Select' }}
                                    </button>
                                }
                            </td>
                        </tr>
                    }
                </tbody>
            </nz-table>
        </nz-card>
    </div>

    <div nz-col [nzSpan]="8">
        @if (!canPackage) {
            <app-unauthorized-access-edit-warning [warning]="'You do not have the necessary permission to package SDKs'"></app-unauthorized-access-edit-warning>
        }
        <nz-card nzTitle="SDK Package Summary" class="shadow-sm">
            
            @if (selectedFiles.length === 0) {
                <div style="text-align: center; color: #999; padding: 20px;">
                    No files selected yet.
                </div>
            }

            <nz-list nzSize="small">
                @for (file of selectedFiles; track $index) {
                    <nz-list-item>
                    
                        <span nz-typography nzEllipsis style="width: 70%;">
                            <span nz-icon nzType="file" style="margin-right: 8px;"></span>
                            {{ file.name }}
                        </span>
                        
                        <ul nz-list-item-actions>
                            <nz-list-item-action>
                                <a (click)="removeSelectedFile(file.id)" style="color: red;">
                                    <span nz-icon nzType="delete"></span>
                                </a>
                            </nz-list-item-action>
                        </ul>
                    </nz-list-item>
                }
                
            </nz-list>

            <nz-divider></nz-divider>

            @if (canPackage) {
                <button nz-button nzType="primary" nzBlock [disabled]="selectedFiles.length === 0" (click)="packageAndDownload()">
                    Download Package ({{ selectedFiles.length }})
                </button>
            }
        </nz-card>
    </div>

</div>